/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment } from "react";
import { AccordionComponent } from "./accordion";
import { CallToActionComponent } from "./call-to-action";
import { CivilSpaceComponent } from "./civilspace";
import { DividerComponent } from "./divider";
import { DocumentListComponent } from "./document-list";
import { EmbedComponent } from "./embed";
import { WebComponentEmbedComponent } from "./embed-webcomponent";
import { FeatureWebpageComponent } from "./feature-webpage";
import { FeedbackComponent } from "./feedback";
import { FeedComponent } from "./feed";
import { FeedComponentCalendar } from "./calendar";
import { FormsComponent } from "./forms";
import { HeadingComponent } from "./heading";
import { HeroCarousel } from "./hero-carousel";
import { IconLinkListComponent } from "./icon-link-list";
import { InfoBoxComponent } from "./info-box";
import { ImageComponent } from "./image";
import { ImageGalleryComponent } from "./image-gallery";
import { ImageListComponent } from "./image-list";
import { LinkButtonComponent } from "./link-button";
import { LinkListComponent } from "./link-list";
import { NavigationListComponent } from "./navigation-list";
import { QuoteComponent } from "./quote";
import { RichTextComponent } from "./rich-text/rich-text";
import { RichTextWithImageComponent } from "./rich-text-with-image";
import { RoutewareCalendarComponent } from "./routeware-calendar";
import { RoutewareWizardComponent } from "./routeware-wizard";
import { TabGroupComponent } from "./tab-group";
import { TocComponent } from "./toc";
import { YoutubeComponent } from "./youtube";
// ---------------- New -----------------------
import { IconCtaComponent } from "./icon-cta";
import { ImageLinkComponent } from "./image-link";
import { PermitDisplayComponent } from "./permit-display";
import { MyPermitDisplayComponent } from "./my-permit-display";
import { PermitSelectComponent } from "./permit-select";
import { ScrollRevealImage } from "./scroll-reveal";
import { CardsSimpleComponent } from "./cards-simple";
import { Hero } from "./hero";
import { HeroSlideshow } from "./hero-slideshow";
import { HighlightComponent } from "./highlight";
import { TimelineComponent } from "./timeline";
import { Testimonial } from "./testimonial";
import { CardsComponent } from "./cards";
import { NewsAndEventsFeedComponent } from "./news-events-feed";
import { NavCardsSimpleComponent } from "./nav-cards-simple";
import { IconLinkTabsComponent } from "./icon-link-tabs";
import { NavCardsComponent } from "./nav-cards";

export const getComponent = (component, field, webpage) => {
    const type = component?.type;

    switch (type) {
        case "component.accordion":
            return <AccordionComponent
                component={component}
                field={field}
            />;

        case "component.call-to-action":
            return <CallToActionComponent
                component={component}
                field={field}
            />;

        case "component.civilspace-engagement":
            return <CivilSpaceComponent
                component={component}
                field={field}
            />;

        case "component.divider":
            return <DividerComponent
                component={component}
                field={field}
            />;

        case "component.document-list":
            return <DocumentListComponent
                component={component}
                field={field}
            />;

        case "component.embed":
            return <EmbedComponent
                component={component}
                field={field}
            />;

        case "component.embed-web-component":
            return <WebComponentEmbedComponent
                component={component}
                field={field}
            />;

        case "component.feature-webpage":
            return <FeatureWebpageComponent
                component={component}
                field={field}
            />;

        case "component.feedback":
            return <FeedbackComponent
                component={component}
                field={field}
            />;

        case "component.feed-calendar":
            return <FeedComponentCalendar
                component={component}
                field={field}
            />;

        case "component.feed-model":
            return <FeedComponent
                component={component}
                field={field}
            />;

        case "component.form":
            return <FormsComponent
                component={component}
                field={field}
            />;

        case "component.hero-carousel":
            return <HeroCarousel
                component={component}
                field={field}
            />;

        case "component.heading":
            return <HeadingComponent
                component={component}
                field={field}
            />;

        case "component.icon-links-list":
            return <IconLinkListComponent
                component={component}
                field={field}
            />;

        case "component.image":
            return <ImageComponent
                component={component}
                field={field}
            />;

        case "component.image-gallery":
            return <ImageGalleryComponent
                component={component}
                field={field}
            />;

        case "component.image-list":
            return <ImageListComponent
                component={component}
                field={field}
            />;

        case "component.info-box":
            return <InfoBoxComponent
                component={component}
                field={field}
            />;

        case "component.link-button":
            return <LinkButtonComponent
                component={component}
                field={field}
            />;

        case "component.links-list":
            return <LinkListComponent
                component={component}
                field={field}
            />;

        case "component.navigation-list":
            return <NavigationListComponent
                component={component}
                webpage={webpage}
                field={field}
            />;

        case "component.quote":
            return <QuoteComponent
                component={component}
                field={field}
            />;

        // rich-text-editor is the legacy implementation
        case "component.rich-text-editor":
        case "component.rich-text":
            return <RichTextComponent
                component={component}
                field={field}
            />;

        case "component.rich-text-with-image":
            return <RichTextWithImageComponent
                component={component}
                field={field}
            />;

        case "component.routeware-calendar":
            return <RoutewareCalendarComponent
                component={component}
                field={field}
            />;

        case "component.routeware-wizard":
            return <RoutewareWizardComponent
                component={component}
                field={field}
            />;

        case "component.tab-panel":
            return <TabGroupComponent
                component={component}
                field={field}
            />;

        case "component.table-of-contents":
            return <TocComponent
                component={component}
                webpage={webpage}
                field={field}
            />;

        case "component.youtube":
            return <YoutubeComponent
                component={component}
                field={field}
            />;

        // --------- New ---------------------
        case "component.cards":
            return <CardsComponent
                component={component}
                field={field}
            />;

        case "component.cards-simple":
            return <CardsSimpleComponent
                component={component}
                field={field}
            />;

        case "component.hero":
            return <Hero
                component={component}
                field={field}
            />;

        case "component.hero-slideshow":
            return <HeroSlideshow
                component={component}
                field={field}
            />;

        case "component.highlight":
            return <HighlightComponent
                component={component}
                field={field}
            />;

        case "component.icon-cta":
            return <IconCtaComponent
                component={component}
                field={field}
            />;

        case "component.icon-link-tabs":
            return <IconLinkTabsComponent
                component={component}
                field={field}
            />;

        case "component.image-link":
            return <ImageLinkComponent
                component={component}
                field={field}
            />;

        case "component.nav-cards-simple":
            return <NavCardsSimpleComponent
                component={component}
                field={field}
            />;

        case "component.news-events-feed":
            return <NewsAndEventsFeedComponent
                component={component}
                field={field}
            />;

        case "component.permit-list":
            return <PermitDisplayComponent
                component={component}
                field={field}
            />;

        case "component.permit-list-auth":
            return <MyPermitDisplayComponent
                component={component}
                field={field}
            />;

        case "component.permit-select":
            return <PermitSelectComponent
                component={component}
                field={field}
            />;

        // case "component.service-list-tabs":
        //     return <ServiceListTabsComponent
        //         component={component}
        //         field={field}
        //     />;

        case "component.scroll-reveal-image":
            return <ScrollRevealImage
                component={component}
                field={field}
            />;

        case "component.testimonial":
            return <Testimonial
                component={component}
                field={field}
            />;

        case "component.testimonials":
            return <Testimonial
                component={component}
                field={field}
            />;

        case "component.timeline":
            return <TimelineComponent
                component={component}
                field={field}
            />;

        case "component.nav-cards":
            return <NavCardsComponent
                component={component}
                field={field}
            />;

        default:
            return <Fragment />;
    }
};
